/**
 * @taskId T649
 * @see functional/Cycles/cycle-5/tasks.md HU-25-FE
 */
import { RefreshCw } from 'lucide-react';
import { Button } from '@flexibilitypay/ui';

import { BreakdownChart } from './BreakdownChart';
import { KpiCards } from './KpiCards';
import { PeriodSelector } from './PeriodSelector';
import { useDashboardKpis } from './hooks/useDashboardKpis';

export function DashboardPage() {
  const { data, isLoading, isError, refetch, isFetching, period, setPeriod } =
    useDashboardKpis();

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 className="text-2xl font-semibold tracking-tight">Dashboard operativo</h2>
          <p className="text-sm text-muted-foreground">
            KPIs y volumen por merchant
            {data?.periodLabel ? ` — ${data.periodLabel}` : ''}
          </p>
        </div>

        <div className="flex items-center gap-3">
          <PeriodSelector
            value={period}
            onChange={setPeriod}
            disabled={isFetching}
          />
          <Button
            size="sm"
            variant="ghost"
            onClick={() => refetch()}
            disabled={isFetching}
            aria-label="Actualizar datos"
            className="h-8 w-8 p-0"
          >
            <RefreshCw
              className={`size-4 ${isFetching ? 'animate-spin' : ''}`}
            />
          </Button>
        </div>
      </div>

      {/* Error state */}
      {isError && (
        <div
          role="alert"
          className="flex items-center justify-between rounded-lg border border-destructive/30 bg-destructive/10 px-4 py-3"
        >
          <p className="text-sm text-destructive">
            No se pudieron cargar los indicadores en este momento.
          </p>
          <Button size="sm" variant="outline" onClick={() => refetch()}>
            Reintentar
          </Button>
        </div>
      )}

      {/* KPI cards */}
      <KpiCards data={data} isLoading={isLoading} />

      {/* Breakdown chart */}
      <BreakdownChart
        data={data?.breakdown}
        isLoading={isLoading}
        periodLabel={data?.periodLabel}
      />
    </div>
  );
}
